export default __webpack_public_path__ + "static/media/EAST1080.34I-34229_-18452_0.9b4a769e.jpg";